<template>
    <div class="image-box">
        <div class="image-content" style='list-style-type: none;width:auto;margin-top:auto; margin-bottom:auto;'>
     
                <div v-for="(item,index) in txtArray" :key="index">
              
                        <el-row :gutter="0" style="padding-top: 10px;">
                            <el-col :xs="16" :sm="12" :md="8" :lg="3" :xl="1" align="middle">
                                <span v-if="item.sender=='mine'">
                                    <el-avatar shape="square" :src="circleUrl"></el-avatar>
                                </span>
                                <span v-else>
                                    <el-avatar shape="square" :src="squareUrl"></el-avatar>
                                </span>
                            
                            </el-col>
                            <el-col :xs="8" :sm="12" :md="16" :lg="21" :xl="21">
                                <div class="bg-color-0" style="white-space: pre-line; word-break:break-all;" v-if="item.sender == 'mine'">{{ item.txt }}</div>
                                <div class="bg-color-1" style="white-space: pre-line; word-break:break-all;" v-if="item.sender == 'bot'">
                                    <div v-if="item.msgArray.length >= 1">
                                        <span v-for="(itemMsg,indexMsg) in item.msgArray" :key="indexMsg"><el-image :preview-src-list="item.msgArray" :src="itemMsg" style="width: 200px;height: 200px;"/></span>
                                    </div>
                                    <div v-else>
                                        {{ item.txt }}
                                    </div>
                                 
                                </div>
                            </el-col>
                        </el-row>
   
                </div>

        </div>
        <div class="image-input">
            <el-form ref="form" :model="form" label-width="180px" :rules="rules">
           
                <div class="image-input-rigth" style="width: 90%;">
                    <el-form-item label="图片内容描述" prop="prompt">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 4}"
                            placeholder="请输入内容"
                            :show-word-limit="true"
                            rows="4"
                            maxlength="1000"
                            minlength="5"
                            :clearable="true"
                            v-model="form.prompt"></el-input>
                    </el-form-item>
                </div>

                <div class="image-input-left">
                    <div class="image-select-size">
                    <el-form-item label="图片生成尺寸" prop="imageSize">

                        <el-select v-model="form.imageSize" placeholder="请选择尺寸">
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>

                    </el-form-item>
                    </div>
                    <div class="image-form-input">
                        <el-form-item label="图片生成数量" prop="num">
                            <el-input-number v-model="form.num" :min="1" :max="5" label="请输入图片生成数量"></el-input-number>
                        </el-form-item>
                    </div>
                    <div class="image-form-button">
                       <el-form-item>
                            <el-button type="primary" @click="onSubmit('form')">立即生成</el-button>
                            <el-button type="primary" @click="resetForm('form')">重置</el-button>
                       </el-form-item>
                    </div>

                </div>
    
            </el-form>
        </div>
    </div>
</template>
<script>
import { subscribe,sendMsg,disSubscribe,closeConnect } from "@/utils/mysocket";
import {Message} from 'element-ui';
    export default {
        name: "ImageChatGPT",
        data(){
            return{
                circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
                squareUrl: "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png",
                sizeList: ["large", "medium", "small"],
                txtArray:[
                 //   {sender:'mine',index:0,radom:'as',txt:'请输入',msgArray:[]},
                 //   {sender:'bot',index:1,radmom:'',txt:'思考中...',msgArray:[]},
                ],
                form: {
                    prompt:'',
                    apiModel:'OpenAi00',
                    imageSize:'1',
                    index:0,
                    type:1,
                    num:5
                },
                queryPage:{
                  apiModel:'OpenAi00',
                  pageid:1,
                  pagesize:1000
                },
                type : 6,
                options: [{
                value: '1',
                label: '1024*1025'
                }, {
                value: '2',
                label: '512*512'
                }, {
                value: '3',
                label: '256*256'
                }],
                rules: {
                imageSize: [
                    { required: true, message: '请选择生成尺寸', trigger: 'change' }
                  ],
                  prompt: [
                    { required: true, message: '请选择输入描述内容', trigger: 'blur' }
                  ],
                  num: [
                    { required: true, message: '请选择输入生成数量', trigger: 'blur' }
                  ],
                }
            };
        },
        methods:{
            onSubmit(formParams) {
            
                this.$refs[formParams].validate((valid) => {
                if (valid) {
                  var minemsg = {sender:'mine',index:this.txtArray.length,radmom:'',txt:this.form.prompt,msgArray:[]};
                  this.txtArray.push(minemsg); 
                  var botmsg = {sender:'bot',index:this.txtArray.length,radmom:'',txt:'思考中...',msgArray:[]};
                  this.txtArray.push(botmsg); 
                  //console.log('submit!');
                  this.form.index = this.txtArray.length;
                  console.log('submit!:'+ this.form.index );
                  sendMsg(this.form);
                  this.resetForm(formParams);
                  this.scrollToBottom();
                } else {
                  Message.error({message: "表单验证失败"})
                  return false;
                }
      
              });
            },
            recordList(){
                let self = this;
                self.postRequest('/newGpt/list',self.queryPage).then(resp =>{
                   // self.txtArray = resp.data.rows;
                    var d = resp.data.rows;
                    for(var i in d){
                        this.scrollToBottom();
                      var txt = {sender:'mine',index:self.txtArray.length,radom:'as',txt:d[i].input,msgArray:[]};
                      self.txtArray.push(txt);
                      var bottxt = {sender:'bot',index:self.txtArray.length,radom:'as',txt:'',msgArray:d[i].result};
                      self.txtArray.push(bottxt);
                    }

                 })
            },
            imageSubscribe(msg){
                   //console.log("image:"+msg);
                   if(msg== null || msg == '' || msg == undefined){
                      return;
                    }
                    if(this.txtArray.length == 0){
                      return;
                    }
                    var index = msg.index;
                    
                    this.txtArray[index-1].msgArray.push(msg.msgArray[0]);
                    this.scrollToBottom();
            },
            resetForm(formParams){
                var mo = this.form.apiModel;
                this.$refs[formParams].resetFields();
                this.form.apiModel = mo
            },
            scrollToBottom(){
              this.$nextTick(()=>{
              let box = this.$el.querySelector(".image-content")
              box.scrollTop = box.scrollHeight
              })
            }
        },
         //销毁页面之前，断开连接
      beforeDestroy: function () {
        //取消订阅
        disSubscribe();
        closeConnect();
      },
      
      destroyed() {
        //closeConnect();//离开路由之后断开websocket连接
      },
      mounted(){
        this.scrollToBottom()
      },
      update(){
        this.scrollToBottom()
      },
      created() {
                //取消订阅
                disSubscribe();
        this.type = this.$route.query.type;
      
        var user = this.getLoginInfo();
        subscribe(this.imageSubscribe,user.email);
        this.recordList();
      }
    }
</script>

<style scoped>
.bg-color-0{
    background-color:#ffffff;
    border-radius: 5px;
    min-height: 40px;
    height: auto;
}
.bg-color-1{
    background-color: #ffffff;
    border-radius: 5px;
    min-height: 40px;
    height: auto;
}
.el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
.image-content{
    width: 100%;
    height: 700px;
   /** background-color: rgb(237, 247, 243); */
    border: 1px solid rgb(237, 247, 243);
    border-radius: 5px;
    overflow: auto;
 
}
.image-input{
    width: 100%;
    height: 300px;
   /** background-color: rgb(237, 247, 243); */
    border: 1px solid rgb(237, 247, 243);
    margin-top: 10px;
    border-radius: 5px;
    padding-top: 10px;
    
}
</style>